import { mutatorAction } from 'satcheljs';
import { getStore } from 'owa-immersive-reader-store';
var closeImmersiveReader = mutatorAction('closeImmersiveReader', function () {
    var store = getStore();
    store.immersiveReaderFrameState = 0 /* Closed */;
    store.apiResponse = null;
});
export default closeImmersiveReader;
//# sourceMappingURL=closeImmersiveReader.js.map